// Persistance locale (profil + classement hors ligne). Tolérant aux navigateurs sans localStorage.
export function loadLocal(key, fallback) {
  try {
    const v = localStorage.getItem(key);
    return v ? JSON.parse(v) : fallback;
  } catch {
    return fallback;
  }
}

export function saveLocal(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* stockage indisponible : on ignore */
  }
}

export function removeLocal(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    /* stockage indisponible : on ignore */
  }
}
